export const modalsEnum = {
  ACTIVATION_CHECKLIST_SUCCESS: 'activation-checklist-success',
  ADD_ACCOUNT_ACTIONS: 'add-account-actions',
  ADD_HOME_VALUE: 'add-home-value',
  ADD_SELF_REPORTED_ASSET: 'add-self-reported-asset',
  CASH_FLOW_LINK_SWITCHBOARD: 'cash-flow-link-switchboard',
  CHAIN_LINKING_SWITCH: 'chain-linking-switch',
  CONFIRMATION: 'confirmation',
  CONTENT_PREFERENCES: 'content-preferences',
  CUSTOM: 'custom',
  DOWNLOAD_APP_QR: 'download-app-qr',
  EDIT_SELF_REPORTED_ASSET: 'edit-self-reported-asset',
  ESTIMATED_MONTHLY_INCOME: 'estimated-monthly-income',
  FLOW: 'flow',
  FREE_MONEY_DETAILS: 'free-money-details',
  INSURANCE_PAINTED_DOOR: 'insurance-painted-door',
  MANUAL_TRANSACTION: 'manual-transaction',
  MY_BILLS_ADD_FLOW: 'my-bills-add-flow',
  MY_BILLS_DETAILS: 'my-bills-details',
  NERDWALLET_PLUS_REWARD_DISMISS: 'nerdwallet-plus-reward-dismiss',
  NERDWALLET_PLUS_REWARD_CELEBRATION: 'nerdwallet-plus-reward-celebration',
  QSG_HURRAY_PLAID: 'qsg-hurray-plaid',
  QSG_HURRAY_TRANSUINON: 'qsg-hurray-transunion',
  QSG_LINK_ANOTHER_ACCOUNT: 'qsg-link-another-account',
  SELF_REPORTED_FINANCIAL_ACCOUNT: 'self-reported-financial-account',
  SELF_REPORTED_INCOME: 'self-reported-income',
  TRANSACTION_CATEGORIES: 'transaction-categories',
  TRANSACTION_DETAILS: 'transaction-details',
  TU_ACTIVATION_PROMO: 'tu-activation-promo',
  UNLINK_PORTAL: 'unlink-portal',
};
